module.exports = __webpack_public_path__ + "static/img/mhaibao1.f33d8cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/mhaibao1.png
// module id = OR0n
// module chunks = 0